<template>
  <div class="c-list-item tl">
    <div class="c-main" @click="jumpToBrief(item)">
      <div class="c-thumb c-default-img">
        <div
          class="c-corner-icon"
          v-if="item.h5Index != null"
        >{{constants.h5CatsAtHome[item.h5Index]}}</div>
        <img :src="item.imageA" />
      </div>
      <div class="pl20 pr20">
        <div class="c-title-wrap">
          <gxxt-tag color="#FF8345" text-color="#fff">{{offlineClassSt[item.status]}}</gxxt-tag>
          <div class="c-title thidden">{{item.name}}</div>
        </div>
        <div class="c-subtitle">{{item.shareDescription}}</div>
        <div class="c-course-info">
          <div class="c-course-time">
            <span class="c-course-info__val">{{formatCourseDate(item.startTime, item.endTime)}}</span>
            <span class="c-course-info__title">上课时间</span>
            <div class="c-split"></div>
          </div>
          <div class="c-course-address">
            <span class="c-course-info__val">{{item.city}}</span>
            <span class="c-course-info__title" v-if="item.multipleCity">多地可选</span>
            <span class="c-course-info__title" v-else>上课地点</span>
            <div class="c-split"></div>
          </div>
          <div class="c-course-price">
            <span class="c-course-info__val">￥{{item.newPrice >= 0? item.newPrice : '--'}}</span>
            <span class="c-course-info__title">学费</span>
            <div class="c-split"></div>
          </div>
          <div class="c-progress">
            <gxxt-circle-percent
              :size="96"
              :value="item.counts - item.surplusNum"
              :total="item.counts"
            ></gxxt-circle-percent>
          </div>
        </div>
      </div>
    </div>
    <!-- 标签 -->
    <div class="c-tags" v-if="item.phaseList && item.phaseList.length > 0">
      <gxxt-tag
        v-for="p in item.phaseList"
        :key="p.resourceId || p.id"
        class="mr20 mb20 relative"
        round
        size="large"
        text-color="#303030"
        @click="jumpToBrief(p)"
      >
        {{p.periods}}期 | {{p.city}} {{formatCourseDate(p.startTime, p.endTime)}}
        <i
          class="c-full-icon"
          v-if="goodsType == constants.goodsType.offlineClass && p.surplusNum <= 5"
        ></i>
      </gxxt-tag>
    </div>
  </div>
</template>

<script>
import { GxxtTag, GxxtCirclePercent } from '@/components'
import dates from '@/utils/dates'
export default {
  components: {
    GxxtTag,
    GxxtCirclePercent,
  },
  props: {
    //   goodsType: ['课程', '训练营', '私教坊', '专栏', '会员VIP'],
    goodsType: {
      type: [Number, String],
      default: 2,
    },
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    origin: {
      type: String,
      default: '',
    },
    adminId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      trainStatus: ['待报名', '报名中', '报名已截止', '已结课'],
      offlineClassSt: ['未发布', '报名中', '已售罄', '已结束', '报名已截止'],
    }
  },
  methods: {
    formatCourseDate(start, end) {
      return dates.formatCourseDate(start, end)
    },
    jumpToBrief(item) {
      this.$router.push({
        name: 'course-home',
        query: {
          goodsId: item.goodsId,
          adminId: this.adminId,
          origin: this.origin,
          goodsType: this.constants.goodsType.offlineClass,
          from: 'timetable',
        },
      })
    },
  },
}
</script>

<style scoped lang="less">
.c-list-item {
  width: 686px;
  padding-bottom: 10px;
  margin-bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.c-thumb {
  width: 686px;
  height: 386px;
  position: relative;
  .c-corner-icon {
    position: absolute;
    top: 0;
    right: 16px;
    width: 42px;
    height: 112px;
    padding-top: 12px;
    font-size: 24px;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    background: url('~@/assets/images/home/corner-icon.png') no-repeat 0 0;
    background-size: 100% 100%;
    text-align: center;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.c-title-wrap {
  display: flex;
  padding-top: 20px;
  align-items: center;
  .c-title {
    margin-left: 16px;
    flex: 1;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
  }
}
.c-subtitle {
  line-height: 50px;
  font-size: 26px;
  color: #888;
}
.c-course-info {
  display: flex;
  font-size: 26px;
  line-height: 40px;
  padding: 10px 0 20px;
  margin-bottom: 10px;

  & > div:last-child {
    .c-split {
      display: none;
    }
  }
  .c-course-info__title {
    display: block;
    color: #888888;
    width: 100%;
  }
  .c-course-info__val {
    display: block;
    color: #ff5500;
    font-weight: bold;
    width: 100%;
  }
  .c-progress {
    flex: 1;
    display: flex;
    justify-content: center;
    height: 100px;
  }
}

.c-course-time,
.c-course-price,
.c-course-address {
  flex-direction: column;
  text-align: center;
  display: flex;
  position: relative;
  justify-content: center;
  height: 100px;
}
.c-course-price,
.c-course-address {
  flex: 138px 0 0;
}
.c-course-time {
  // flex: 1;
  min-width: 200px;
  padding:0 20px;
  margin-left: -20px;
}
.c-split {
  width: 0px;
  height: 72px;
  border-right: 2px solid #f4f4f4;
  position: absolute;
  top: 15px;
  right: 0;
}
.c-full-icon {
  display: block;
  width: 60px;
  height: 33px;
  background: url('~@/assets/images/full-icon.png') no-repeat 0 0;
  background-size: 60px 33px;
  position: absolute;
  top: -25px;
  right: -20px;
}
.c-tags {
  padding-top: 20px;
  margin: 0 20px;
  border-top: 1px solid #d8d8d8;
}
.c-list-item * {
  cursor: pointer;
}
.flex-reverse-box {
  height: 30px;
  flex: auto 0 0;
  flex-direction: row-reverse;
  justify-content: flex-end;
  .c-course-info__title {
    width: auto;
    text-align: left;
  }
  .c-course-info__val {
    width: auto;
    text-align: left;
    padding-left: 12px;
    padding-right: 40px;
  }

  .c-split {
    height: 26px;
    top: 10px;
  }
}
.flex-reverse-box.c-course-price .c-course-info__title {
  text-align: right;
  padding-left: 40px;
}
// .flex-reverse-box{
//   flex: 300px 0 0;
//   flex-direction: row-reverse;

// }
</style>